import { FC, MouseEventHandler, PropsWithChildren } from 'react';

import classNames from 'classnames';

import styles from 'components/CampaignCard/BannersTabs/TabLink/TabLink.module.less';

interface TabLinkProps extends PropsWithChildren {
    onClick?: MouseEventHandler;
    isActive: boolean;
    dataQa: string;
}

const TabLink: FC<TabLinkProps> = ({ onClick, children, isActive, dataQa }) => {
    return (
        <a
            className={classNames(styles.bannerTab, { [styles.bannerTabActive]: isActive })}
            onClick={onClick}
            data-qa={dataQa}
        >
            {children}
        </a>
    );
};

export default TabLink;
